import { BUSINESS_INFO } from './business-info';
import { Article, LegalLayout, List } from './LegalLayout';

/**
 * 利用規約。
 *
 * 事業者名や連絡先は business-info.ts のプレースホルダを参照している。
 * **法務レビューを通していない下書き**なので、公開前に必ず確認を取ること
 * (docs/deployment.md の「法務ページ」を参照)。
 */
export function TermsPage() {
  return (
    <LegalLayout
      title="利用規約"
      lead={`本規約は、${BUSINESS_INFO.companyName}（以下「当社」）が提供する工数・アサイン予実管理サービス「INOU」（以下「本サービス」）の利用条件を定めるものです。本サービスを利用する法人・団体および利用者（以下あわせて「お客様」）は、本規約に同意したうえで本サービスを利用するものとします。`}
    >
      <Article heading="第1条（定義）">
        <List
          items={[
            '「テナント」とは、お客様ごとに割り当てられる本サービス上の独立した領域およびそれに対応するサブドメインをいいます。',
            '「利用者」とは、テナントに登録され、本サービスを利用する個人をいいます。',
            '「シート」とは、利用者 1 名が本サービスを利用するための権利の単位をいいます。',
            '「MCP 接続」とは、お客様が利用する AI クライアントから Model Context Protocol を用いて本サービスへ接続する機能をいいます。',
            '「登録データ」とは、お客様が本サービスに入力し、または MCP 接続を通じて記録した工数、プロジェクト、アサインその他の情報をいいます。',
          ]}
        />
      </Article>

      <Article heading="第2条（アカウントの登録）">
        <List
          items={[
            'お客様は、当社所定の方法により申請し、当社が承諾したときに本サービスの利用契約が成立します。',
            'お客様は、登録事項に虚偽がないこと、および変更が生じた場合には速やかに更新することに同意します。',
            '当社は、申請者が過去に本規約に違反したことがある場合、その他当社が不適当と判断した場合には、登録を承諾しないことがあります。',
            '同一のサブドメインは先に登録を完了したお客様に割り当てられます。当社は、当社の運営に必要なサブドメインを留保します。',
          ]}
        />
      </Article>

      <Article heading="第3条（アカウントの管理）">
        <List
          items={[
            'お客様は、自己の責任においてパスワード、認証情報および個人アクセストークン（PAT）を管理するものとします。',
            '認証情報および PAT を第三者に開示、貸与または共有してはなりません。',
            '認証情報を用いて行われた行為は、当社の故意または重過失による場合を除き、お客様による行為とみなします。',
            '認証情報の漏えいまたはそのおそれを知ったときは、直ちに当社へ通知し、当社の指示に従うものとします。',
          ]}
        />
      </Article>

      <Article heading="第4条（料金および支払い）">
        <List
          items={[
            '本サービスの利用料金はシート単位の月額課金とし、その金額および区分は当社ウェブサイトに掲示するところによります。',
            '課金対象となるシート数は、テナントに登録された利用者のうち利用が可能な状態にある者の数によって決まります。当社が指定する方法により無効化された利用者はシートを消費しません。',
            '利用料金の請求および決済は、当社が指定する決済代行事業者を通じて行われます。',
            '当社は、利用料金を改定することがあります。改定にあたっては、第10条に定める方法により事前に通知します。',
            '当社は、法令に定める場合を除き、支払われた利用料金を返還しません。',
          ]}
        />
      </Article>

      <Article heading="第5条（無料トライアル）">
        <p>
          当社は、新規に登録したお客様に対し、当社が定める期間および範囲の無料トライアルを提供することがあります。
          トライアル期間中の提供内容は当社ウェブサイトに掲示するところによります。
        </p>
        <p>
          トライアル期間が終了し、かつ有効なシートの購入がない場合、当社は本サービスの機能のうち
          登録データの参照を除く部分の利用を制限することがあります。この場合であっても、
          お客様は当社が定める期間、登録データを参照および取得することができます。
        </p>
      </Article>

      <Article heading="第6条（禁止事項）">
        <p>お客様は、本サービスの利用にあたり、次の行為を行ってはなりません。</p>
        <List
          items={[
            '法令または公序良俗に違反する行為',
            '当社、他のお客様または第三者の権利を侵害する行為',
            '本サービスの運営を妨害し、またはそのおそれのある行為',
            '本サービスに過度の負荷を与える態様でのアクセスその他の不正な方法によるアクセス',
            '自己に割り当てられたテナント以外のデータへ接近を試みる行為',
            'リバースエンジニアリング、逆コンパイルその他の方法により本サービスのソースコードを取得しようとする行為',
            '本サービスを通じて取得した情報を、本サービスの利用目的を超えて利用する行為',
            'その他、当社が不適切と合理的に判断する行為',
          ]}
        />
      </Article>

      <Article heading="第7条（登録データの取り扱い）">
        <List
          items={[
            '登録データに関する権利はお客様に帰属します。当社は、本サービスの提供、保守および改善に必要な範囲でのみこれを利用します。',
            '当社は、登録データをテナント単位で分離して保管します。',
            '当社は、法令に基づく場合その他正当な理由がある場合を除き、登録データを第三者に開示しません。',
            'お客様は、本サービスが提供する機能により登録データを取得することができます。利用契約の終了後、当社は当社が定める期間の経過をもって登録データを削除することができます。',
          ]}
        />
      </Article>

      <Article heading="第8条（本サービスの停止・変更）">
        <List
          items={[
            '当社は、保守、障害対応その他やむを得ない事由があるときは、事前の通知なく本サービスの全部または一部の提供を停止することがあります。',
            '当社は、本サービスの内容を変更し、または提供を終了することがあります。提供を終了する場合には、当社が相当と認める期間をもって事前に通知します。',
          ]}
        />
      </Article>

      <Article heading="第9条（免責および責任の制限）">
        <List
          items={[
            '本サービスが記録する工数の区分および分類は、AI による推定を含みます。当社は、その結果が会計上または税務上の要件を満たすことを保証しません。お客様は、確定にあたり自らの責任において内容を確認するものとします。',
            '当社は、本サービスが中断なく提供されること、および瑕疵がないことを保証しません。',
            '当社がお客様に対して負う損害賠償の責任は、当社の故意または重過失による場合を除き、責任の原因となった事由が生じた月に先立つ 12 か月間にお客様が当社に支払った利用料金の総額を上限とします。',
            '当社は、いかなる場合も、逸失利益その他の間接損害について責任を負いません。',
          ]}
        />
      </Article>

      <Article heading="第10条（本規約の変更）">
        <p>
          当社は、本規約を変更することがあります。変更にあたっては、変更後の内容および効力発生日を、
          本サービス上またはお客様の登録した連絡先への通知により、効力発生日までに周知します。
          効力発生日以後にお客様が本サービスを利用したときは、変更後の本規約に同意したものとみなします。
        </p>
      </Article>

      <Article heading="第11条（準拠法および管轄）">
        <p>
          本規約の準拠法は日本法とします。本サービスに関して当社とお客様との間に生じた紛争については、
          {BUSINESS_INFO.address}を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>
      </Article>

      <Article heading="お問い合わせ">
        <p>本規約に関するお問い合わせは {BUSINESS_INFO.contactEmail} までご連絡ください。</p>
      </Article>
    </LegalLayout>
  );
}
